
import React, { useState, useEffect } from 'react';
import { Sparkles, BrainCircuit, Loader2 } from 'lucide-react';

interface AiProcessingStateProps {
    logs: string[];
    title?: string;
    subtext?: string;
}

const AiProcessingState: React.FC<AiProcessingStateProps> = ({
    logs,
    title = "Froukje is aan het werk...",
    subtext = "Dit kan tot 30 seconden duren. Even geduld a.u.b."
}) => {
    const [currentLog, setCurrentLog] = useState(logs[logs.length - 1] || "Starten...");

    useEffect(() => {
        if (logs.length > 0) {
            setCurrentLog(logs[logs.length - 1]);
        }
    }, [logs]);

    return (
        <div className="flex flex-col items-center justify-center h-[400px] w-full bg-white rounded-2xl border border-slate-100 shadow-sm p-8 animate-fadeIn">

            {/* Avatar Container with Pulse Effect */}
            <div className="relative mb-8">
                <div className="absolute inset-0 bg-purple-100 rounded-full animate-ping opacity-20"></div>
                <div className="relative w-24 h-24 bg-gradient-to-br from-[#e51b23] to-purple-600 rounded-full flex items-center justify-center shadow-xl p-1">
                    <div className="w-full h-full bg-white rounded-full flex items-center justify-center overflow-hidden border-2 border-white/50">
                        <img
                            src="https://api.dicebear.com/7.x/avataaars/svg?seed=Froukje&backgroundColor=ffdfbf"
                            alt="Froukje AI"
                            className="w-20 h-20 object-cover"
                        />
                    </div>

                    {/* Orbiting Elements */}
                    <div className="absolute -right-2 -top-2 bg-white p-1.5 rounded-full shadow-md animate-bounce delay-100">
                        <Sparkles size={16} className="text-amber-400 fill-amber-400" />
                    </div>
                    <div className="absolute -left-2 -bottom-2 bg-white p-1.5 rounded-full shadow-md animate-bounce delay-300">
                        <BrainCircuit size={16} className="text-purple-500" />
                    </div>
                </div>
            </div>

            <h3 className="text-xl font-black text-slate-900 mb-2 text-center">{title}</h3>
            <p className="text-slate-400 text-sm font-medium mb-8 text-center max-w-md">{subtext}</p>

            {/* Log Feed */}
            <div className="w-full max-w-sm bg-slate-50 rounded-xl p-4 border border-slate-100 relative overflow-hidden">
                <div className="absolute top-0 left-0 w-1 h-full bg-gradient-to-b from-[#e51b23] to-purple-600"></div>
                <div className="space-y-3">
                    {logs.slice(-3).map((log, idx) => (
                        <div key={idx} className={`flex items-center gap-3 text-sm ${idx === logs.slice(-3).length - 1 ? 'text-slate-900 font-bold' : 'text-slate-400'}`}>
                            {idx === logs.slice(-3).length - 1 ? (
                                <Loader2 size={14} className="animate-spin text-purple-600 shrink-0" />
                            ) : (
                                <div className="w-3.5 h-3.5 rounded-full bg-emerald-100 flex items-center justify-center shrink-0">
                                    <div className="w-1.5 h-1.5 rounded-full bg-emerald-500"></div>
                                </div>
                            )}
                            <span className="truncate">{log}</span>
                        </div>
                    ))}
                    {logs.length === 0 && (
                        <div className="flex items-center gap-3 text-sm text-slate-900 font-bold">
                            <Loader2 size={14} className="animate-spin text-purple-600 shrink-0" />
                            <span>Initialiseren...</span>
                        </div>
                    )}
                </div>
            </div>

        </div>
    );
};

export default AiProcessingState;
